export function formatTalkJsTime(
  value: number,
  unit: string,
  timestamp: string
) {
  let textDate = '';
  if (unit.includes('second')) {
    textDate = 'just now';
  } else if (unit.includes('year') || unit.includes('month')) {
    textDate = new Date(timestamp).toLocaleString('default', {
      month: 'short',
      year: 'numeric',
      day: 'numeric',
    });
  } else {
    textDate = `${value}${unit[0]}`;
  }
  return textDate;
}

export function formatDate(date: Date | string, time: boolean) {
  const runtimeLocale = window.navigator.language || 'default';
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  if (time) {
    options.hour = 'numeric';
    options.minute = 'numeric';
  }

  const dateFormatter = new Intl.DateTimeFormat(runtimeLocale, options);

  if (typeof date == 'string') {
    date = new Date(date);
  }

  return dateFormatter.format(date);
}
